export default __webpack_public_path__ + "static/media/uwu.fbf9d2ff.jpg";